module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Shopping/Gift-11a044fc84c7e3af561d28999a9e66db7c0ced3e293f24176f1a4fab598791a8.svg";